import { useEffect } from "react";

/**
 * Escape and scroll lock for a portaled dialog.
 * Capture phase so the flyer modal stays open when this dialog closes.
 */
export function useOverlayDismiss(onClose) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key !== "Escape") return;
      event.preventDefault();
      event.stopPropagation();
      onClose();
    };
    document.addEventListener("keydown", onKey, true);
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey, true);
      document.body.style.overflow = previous;
    };
  }, [onClose]);
}
